import React, { useEffect, useState } from "react";
import { IonAvatar, IonButton, IonIcon } from "@ionic/react";
import { camera } from "ionicons/icons";

import { usePhoto } from "./../../../../hooks/usePhoto";
import "./ProfilePic.scss";

interface ProfilePicProps {
  setProfilePic: (pic: string) => void;
  initValue: string;
}

const ProfilePictureCompo: React.FC<ProfilePicProps> = (prop, ref) => {
  const [base64, setBase64] = useState("");

  const { takePhoto, photos } = usePhoto();

  useEffect(() => {
    setProfilePicture();
  }, [photos]);

  const setProfilePicture = () => {
    var initValueBase = prop.initValue == null ? "" : prop.initValue;
    var bSixtyFoour = photos != undefined ? photos.base64 : initValueBase;
    setBase64(bSixtyFoour);
    prop.setProfilePic(bSixtyFoour);
  };

  return (
    <div className="profilepic">
      <IonAvatar className="ion-avatar">
        {/* <img src={photos?.base64} ref={inputRef}/> */}
        <img
          src={base64 !== "" ? base64 : "/assets/images/defaultProfilePic.png"}
          alt=""
        />
        {/* <img src="/assets/images/defaultProfilePic.png"  /> */}
        <IonButton
          onClick={() => takePhoto()}
          className="ion-avatar__ion-button"
          fill="clear"
        >
          <IonIcon
            className="ion-avatar__IonIcon"
            slot="icon-only"
            icon={camera}
          />
        </IonButton>
      </IonAvatar>
    </div>
  );
};

export default ProfilePictureCompo;
